import OrderOptimizerListParams, {
  OrderOptimizerListParamsStatus,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list-params";
import OrderOptimizerRailyListingFilter, {
  OrderOptimizerRailyListingIgnoreDriverRoutesFilter,
  OrderOptimizerRailyListingMaximumDelayFilter,
  OrderOptimizerRailyListingMaximumHaltingTimeFilter,
  OrderOptimizerRailyListingOrderHumanIdFilter,
} from "./types/order-optimizer-raily-listing-filter";
import OrderOptimizerRailyListingFilterType from "./types/order-optimizer-raily-listing-filter-type";
import { OrderOptimizerRailyListingItemStatus } from "./types/order-optimizer-raily-listing-item";

const createStatus = (
  status: OrderOptimizerRailyListingItemStatus,
): OrderOptimizerListParamsStatus => {
  switch (status) {
    case OrderOptimizerRailyListingItemStatus.INTERESTING:
      return OrderOptimizerListParamsStatus.INTERESTING;
    case OrderOptimizerRailyListingItemStatus.PENDING:
      return OrderOptimizerListParamsStatus.PENDING;
    case OrderOptimizerRailyListingItemStatus.REJECTED:
      return OrderOptimizerListParamsStatus.REJECTED;
  }
};

const create = (
  filters: OrderOptimizerRailyListingFilter[],
  page: number,
  pageSize: number,
): OrderOptimizerListParams => {
  const ignoreDriverRoutes = filters.find(
    (filter) =>
      filter.type === OrderOptimizerRailyListingFilterType.IGNORE_DRIVER_ROUTES,
  )?.value as
    | OrderOptimizerRailyListingIgnoreDriverRoutesFilter["value"]
    | undefined;

  const ignoreTaxi = filters
    .filter(
      (filter) =>
        filter.type === OrderOptimizerRailyListingFilterType.IGNORE_TAXI,
    )
    .map((filter) => filter.value);

  const ignoreOnlyWithTaxi = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderOptimizerRailyListingFilterType.IGNORE_ONLY_WITH_TAXI,
    )
    .map((filter) => filter.value);

  const ignoreCargo = filters
    .filter(
      (filter) =>
        filter.type === OrderOptimizerRailyListingFilterType.IGNORE_CARGO,
    )
    .map((filter) => filter.value);

  const ignoreOnlyWithCargo = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderOptimizerRailyListingFilterType.IGNORE_ONLY_WITH_CARGO,
    )
    .map((filter) => filter.value);

  const statusFilter = filters.find(
    (filter) => filter.type === OrderOptimizerRailyListingFilterType.STATUS,
  )?.value;

  return {
    orderHumanId: filters.find(
      (filter) =>
        filter.type === OrderOptimizerRailyListingFilterType.ORDER_HUMAN_ID,
    )?.value as
      | OrderOptimizerRailyListingOrderHumanIdFilter["value"]
      | undefined,
    page: page,
    pageSize: pageSize,
    maximumDelay: filters.find(
      (filter) =>
        filter.type === OrderOptimizerRailyListingFilterType.MAXIMUM_DELAY,
    )?.value as
      | OrderOptimizerRailyListingMaximumDelayFilter["value"]
      | undefined,
    maximumHaltingTime: filters.find(
      (filter) =>
        filter.type ===
        OrderOptimizerRailyListingFilterType.MAXIMUM_HALTING_TIME,
    )?.value as
      | OrderOptimizerRailyListingMaximumHaltingTimeFilter["value"]
      | undefined,
    mergePlanEntries: ignoreDriverRoutes ? false : undefined,
    ignoreCargo: ignoreCargo,
    ignoreOnlyWithCargo: ignoreOnlyWithCargo,
    ignoreOnlyWithTaxi: ignoreOnlyWithTaxi,
    ignoreTaxi: ignoreTaxi,
    status:
      statusFilter && !statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
    excludeStatus:
      statusFilter && statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
  };
};

const orderOptimizerRailyListingLoadParamsFactory = {
  create,
};

export default orderOptimizerRailyListingLoadParamsFactory;
